var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-wrap"},[_c('label',[(_vm.label)?_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.label))]):_vm._e(),_vm._t("default")],2),(_vm.hint)?_c('Hint',{attrs:{"hint":_vm.hint}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }